import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ImportModelDialogComponent } from './import-model-dialog.component';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { GalleryModule } from 'src/app/gallery/gallery.module';



@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    GalleryModule
  ],
  declarations: [
    ImportModelDialogComponent
  ],
  exports: [
    ImportModelDialogComponent
  ],
  entryComponents: [
    ImportModelDialogComponent
  ]
})
export class ImportModelDialogModule { }
